import {EventBusInstance, Logger} from "@sap/cpaas-commlib-lib";
import { Component } from "inferno";
import { Button, Form, FormGroup, Input, Label } from "inferno-bootstrap";
import { T } from "inferno-i18next";
import { AppState, Configuration, Parameter } from "../../services/configuration";
import { MessageProvider, MessageType } from "../../services/messageProvider";
import { Bundle } from '../../services/translationProvider';
import { resizeApp } from "../../utils/util";
import { Header } from "./Header";
import { QueueList } from "./QueueList";
import { CommlibService } from "../../services/commlibService";

export class Login extends Component<any, any> {

	constructor(props: any) {
		super(props);
	}

	state: {
		activeQueue: string,
		userName: string,
		userAddress: string,
	} = {
			activeQueue: undefined,
			userName: undefined,
			userAddress: undefined,
		};
	private page: HTMLElement;

	componentDidMount() {

		if (Configuration.chatQueues.length > 0) {
			this.setActiveQueue(Configuration.chatQueues[0].address);
		} else if (Configuration.queues.length > 0) {
			this.setActiveQueue(Configuration.queues[0].address);
		}
		this.setState({ userName: Configuration.userName, userAddress: Configuration.userAddress });
		EventBusInstance.subscribe(Configuration.event, this.onConfigurationUpdate, this, Configuration.component);
		EventBusInstance.subscribe(Configuration.startWebChatEvent, this.resize, this, Configuration.component);
		this.resize();
	}

	componentWillUnmount() {
		EventBusInstance.unsubscribe(Configuration.event, this.onConfigurationUpdate, this, Configuration.component);
		EventBusInstance.unsubscribe(Configuration.startWebChatEvent, this.resize, this, Configuration.component);

	}

	onConfigurationUpdate(channelId: string, eventId: string, data: Parameter[]) {
		if (data.indexOf(Parameter.userAddress) !== -1) {
			this.setState({ userAddress: Configuration.userAddress });
		}
		if (data.indexOf(Parameter.userName) !== -1) {
			this.setState({ userName: Configuration.userName });
		}
		if (data.indexOf(Parameter.queues) !== -1 || data.indexOf(Parameter.chatQueues) !== -1) {
			if (Configuration.chatQueues.length > 0) {
				this.setActiveQueue(Configuration.chatQueues[0].address);
			} else if (Configuration.queues.length > 0) {
				this.setActiveQueue(Configuration.queues[0].address);
			}
		}
		if (data.indexOf(Parameter.queues) !== -1 || data.indexOf(Parameter.chatQueues) !== -1 || data.indexOf(Parameter.showLogin) !== -1) {
			this.forceUpdate(this.resize);
		}
	}

	resize = () => {
		resizeApp(Configuration.maxWidth, this.page.offsetHeight);
		if (this.page.offsetHeight > Configuration.maxHeight) {
			this.page.style.height = "100%";
		} else {
			this.page.style.height = "";
		}
	};

	setActiveQueue = (activeQueue: string) => {
		this.setState({ activeQueue });
		AppState.selectedQueue = activeQueue;
	};

	onClose = (event: MouseEvent) => {
		MessageProvider.sendMessage(MessageType.state, false);
		// disconnect WS
		AppState.disconnecting = true;
		CommlibService.disconnect().catch(()=>{
			// ignore, it can't fail anyway
		});
	};

	onSubmit = (event: SubmitEvent) => {
		this.props.startChat(this.state.activeQueue);
		event.preventDefault();
	};

	onFormKeyPress = (event: any) => {
		var key = event.charCode || event.keyCode || 0;
		if (key == 13) event.preventDefault(); //Prevent submitting form and starting chat by pressing enter
	};

	onInputKeyPress = (event: any) => {
		const target = event.target as HTMLInputElement;
		this.resetCustomValidity(target);
	};

	onInputValueChange = (event: any) => {
		const target = event.target as HTMLInputElement;
		switch (target.id) {
			case "userName": 
				Configuration.userName = target.value;
				this.setState({ userName: target.value });
				break;
			case "userEmail":
				Configuration.userAddress = target.value;
				this.setState({ userAddress: target.value });
				break;
			default: return;
		}
		this.setValidityMessage(event);
		target.reportValidity();  // Show message immediately, without waiting for next form submit
	};

	resetCustomValidity = (target: HTMLInputElement) => {
		// If setCustomValidity has been called for element with other value than empty string, then element's ValidityState.customError===true --> ValidityState.valid===false --> Value will always remain "invalid".
		target.setCustomValidity("");  // Reset customEror to false
	};

	setValidityMessage = (event: any) => {
		const target = event.target as HTMLInputElement;
		this.resetCustomValidity(target); // Must reset customError before checking validity.valid
		if (!target.validity?.valid) {
			let invalidMsg;
			switch (target.id) {
				case "userName": 
					invalidMsg = Bundle.t("VCC_XMSG_LOGIN_USER_NAME_INVALID");
					break;
				case "userEmail":
					invalidMsg = Bundle.t("VCC_XMSG_LOGIN_USER_EMAIL_INVALID");
					break;
				default: return;
			}
			target.setCustomValidity(invalidMsg);
		}
	};

	render() {
		return (
			<div ref={(node: HTMLElement) => this.page = node} style={{ maxHeight: Configuration.maxHeight }} className="d-flex flex-column w-100 login-page">
				<div>
					<Header minimized={false} onClose={this.onClose} />
				</div>
				<div className="d-flex flex-column w-100 mh-100 login-form" style={{ "overflow-y": "auto" }}>
					<Form id="loginForm" className="m-4 mb-0" onSubmit={this.onSubmit} onKeyPress={this.onFormKeyPress}>
						{Configuration.showLogin && (
							<>
								<FormGroup>
									<Label className={Configuration.mandatoryLogin ? "form-label-required" : undefined}><T i18nKey="VCC_XFLD_LOGIN_USER_NAME">X</T></Label>
									<Input id="userName" maxLength={256} type="text" required={Configuration.mandatoryLogin} placeholder=" " value={this.state.userName} onKeyPress={this.onInputKeyPress} onChange={this.onInputValueChange} onInvalid={this.setValidityMessage}/>
								</FormGroup>
								<FormGroup>
									<Label className={Configuration.mandatoryLogin ? "form-label-required" : undefined}><T i18nKey="VCC_XFLD_LOGIN_USER_EMAIL">X</T></Label>
									<Input id="userEmail" type="email" required={Configuration.mandatoryLogin} placeholder=" " value={this.state.userAddress} onKeyPress={this.onInputKeyPress} onChange={this.onInputValueChange} onInvalid={this.setValidityMessage}/>
								</FormGroup>
							</>
						)}
						<div className="m-4 flex-grow-1 flex-shrink-1" style={{ "overflow-y": "auto", "min-height": "80px" }}>
							<QueueList queues={Configuration.chatQueues} items={Configuration.queues} activeQueue={this.state.activeQueue} setActive={this.setActiveQueue} />
						</div>
						<div className="mb-4 d-flex flex-shrink-0 justify-content-center">
							<Button type="submit" color="primary" className="pl-4 pr-4">
								<T i18nKey="VCC_XBUT_LOGIN_BUTTON_START">X</T>
							</Button>
						</div>
					</Form>
				</div>
			</div>
		);
	}
}
